import { useContext, useEffect } from "react";
import {
  isMobile,
  isTablet,
  isIOS,
  isAndroid,
  isWindows,
  browserName,
} from "react-device-detect";
import RoleContext from "../context/roleContext";
import { getSession } from "./localSession";

/**
 * This function is used to get device data
 *
 */
export function getDeviceData() {
  const device_name = browserName;
  let device_type;
  switch (true) {
    case isMobile:
      device_type = "Mobile";
      break;
    case isTablet:
      device_type = "Tablet";
      break;
    case isIOS:
      device_type = "iOS";
      break;
    case isAndroid:
      device_type = "Android";
      break;
    case isWindows:
      device_type = "Windows";
      break;
    default:
      device_type = "Desktop";
  }

  const deviceData = {
    device_name: device_name,
    device_type: device_type,
    device_id: setandgetCookies(),
  };

  return deviceData;
}

export function setandgetCookies() {
  var cookies = document.cookie.split(";");
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].trim();
    if (cookie.indexOf("myCookie=") === 0) {
      return cookie.split("myCookie=")[1];
    }
  }
  const timestamp = new Date().getTime();
  document.cookie = `myCookie=${timestamp}; path=/`;
  return timestamp.toString();
}

/**
 * This function is used to check whether user is login or not
 * @returns boolean
 */
export function isLogin() {
  const _token = getSession();
  if (_token !== undefined && _token !== "" && _token !== null) {
    return true;
  } else {
    return false;
  }
}

/**
 * This function is used to get header of api
 * @returns header for api
 */
export function getHeader() {
  return {
    headers: {
      accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("_token")}`,
    },
  };
}

export function getColoroCode(color) {
  let colorCode = "";
  switch (color) {
    case "color-gray":
      colorCode = "e7e7e7";
      break;
    case "color-cyan":
      colorCode = "98d7e4";
      break;
    case "color-light-purple":
      colorCode = "e3d7ff";
      break;
    case "color-light-pink":
      colorCode = "fbd3e0";
      break;
    case "color-dark-blue":
      colorCode = "4986e7";
      break;
    case "color-dark-cyan":
      colorCode = "2da2bb";
      break;
    case "color-dark-purple":
      colorCode = "b99aff";
      break;
    case "color-dark-pink":
      colorCode = "f691b2";
      break;
    case "color-dark-yellow":
      colorCode = "f4e37f";
      break;
    case "color-light-yellow":
      colorCode = "fdedc1";
      break;
    case "color-saffron":
      colorCode = "ffad46";
      break;
    case "color-dark-red":
      colorCode = "e54a4a";
      break;
    case "color-dark-green":
      colorCode = "16a765";
      break;
    case "color-dark-green2":
      colorCode = "42d692";
      break;
    case "color-light-green":
      colorCode = "b3efd3";
      break;
    case "color-light-green2":
      colorCode = "a1d9be";
      break;
    default:
      colorCode = "";
      break;
  }

  return colorCode;
}

export function getColoroCodeString(color) {
  let colorCode = "";
  switch (color) {
    case "e7e7e7":
      colorCode = "color-gray";
      break;
    case "98d7e4":
      colorCode = "color-cyan";
      break;
    case "e3d7ff":
      colorCode = "color-light-purple";
      break;
    case "fbd3e0":
      colorCode = "color-light-pink";
      break;
    case "4986e7":
      colorCode = "color-dark-blue";
      break;
    case "2da2bb":
      colorCode = "color-dark-cyan";
      break;
    case "b99aff":
      colorCode = "color-dark-purple";
      break;
    case "f691b2":
      colorCode = "color-dark-pink";
      break;
    case "f4e37f":
      colorCode = "color-dark-yellow";
      break;
    case "fdedc1":
      colorCode = "color-light-yellow";
      break;
    case "ffad46":
      colorCode = "color-saffron";
      break;
    case "e54a4a":
      colorCode = "color-dark-red";
      break;
    case "16a765":
      colorCode = "color-dark-green";
      break;
    case "42d692":
      colorCode = "color-dark-green2";
      break;
    case "b3efd3":
      colorCode = "color-light-green";
      break;
    case "a1d9be":
      colorCode = "color-light-green2";
      break;
    default:
      colorCode = "";
      break;
  }

  return colorCode;
}

export function getColoroCodeStringText(color) {
  let colorText = "";
  switch (color) {
    case "4986e7":
      colorText = "text-white";
      break;
    case "2da2bb":
      colorText = "text-white";
      break;
    case "b99aff":
      colorText = "text-white";
      break;
    case "f691b2":
      colorText = "text-white";
      break;
    case "e54a4a":
      colorText = "text-white";
      break;
    case "16a765":
      colorText = "text-white";
      break;
    default:
      colorText = "";
      break;
  }

  return colorText;
}

export function getColoroCodeCloseText(color) {
  let colorText = "";
  switch (color) {
    case "4986e7":
      colorText = "white";
      break;
    case "2da2bb":
      colorText = "white";
      break;
    case "b99aff":
      colorText = "white";
      break;
    case "f691b2":
      colorText = "white";
      break;
    case "e54a4a":
      colorText = "white";
      break;
    case "16a765":
      colorText = "white";
      break;
    default:
      colorText = "#313b5c";
      break;
  }

  return colorText;
}

export const getRandomText = [
  "Searching high and low for your answer!",
  "Hang on while we sift through our knowledge base!",
  "We're scanning our database to find your answer.",
  "Please wait patiently while we comb through our resources.",
  "We're searching every nook and cranny for your answer.",
  "We're turning over every stone to find the information you need!",
  "Just a moment while we track down your answer.",
  "We're on the hunt for the perfect response to your question.",
  "We're digging through our archives to find your answer!",
  "We're searching far and wide to get you the information you need!",
  "We're looking into the depths of our data to get you an accurate answer.",
  "Please bear with us while we mine our resources for your answer.",
  "We're searching like Sherlock Holmes to find your answer.",
  "We're analyzing your query with our advanced algorithms.",
  "We're digging deep to unearth the answer to your question.",
  "We're working hard to provide you with the most accurate response.",
  "We're processing your request with lightning-fast speed.",
  "We're scouring our resources to provide you with the best answer.",
  "We're exploring every avenue to get you the right answer.",
  "Please hold on while we work our magic to find your answer.",
  "We're sorting through our data to provide you with the best response.",
  "We're running your query through our sophisticated search engine.",
  "We're investigating all possibilities to get you the answer you need.",
  "Please wait a moment while we gather the information you need.",
  "We're working hard to ensure that you get the most accurate and helpful response to your question.",
];

/**
 * function for checking role rights as per module
 * @param {*} permissionFor
 * @param {*} moduleName
 * @returns
 */
/* let permissionArraya = [
  {
    "uuid": "fe55085d-f3bc-41a5-8994-c717c4f63302",
    "name": "Create Documents",
    "Permissions": [
      "View",
      "Write",
      "Delete",
      "Sync",
      "Unsync",
      "Archive",
      "Unarchive"
    ]
  },
  {
    "uuid": "fb2a7a9d-d893-4633-a195-f0a76edd6267",
    "name": "Upload Documents",
    "Permissions": [
      "View",
      "Upload",
      "Delete",
      "Sync",
      "Unsync",
      "Archive",
      "Unarchive",
      "Download"
    ]
  },
  {
    "uuid": "58a7996a-cff5-416b-b47d-969bc0fb56b9",
    "name": "Labels",
    "Permissions": [
      "Add",
      "Update",
      "Delete"
    ]
  },
  {
    "uuid": "8a02007b-dbd2-48cb-87ab-7da163d39dad",
    "name": "Users",
    "Permissions": [
      "Add",
      "Update",
      "Delete"
    ]
  },
  {
    "uuid": "eae07c71-3514-4e03-9864-5502f0b022b5",
    "name": "Roles",
    "Permissions": [
      "Add",
      "Update",
      "Delete"
    ]
  },
  {
    "uuid": "c703e3ca-4109-472e-a4c7-63fa77eec8a7",
    "name": "Profile",
    "Permissions": [
      "View",
      "Update"
    ]
  },
  {
    "uuid": "3c1b57c7-aebb-4c29-a2c0-cada66753f35",
    "name": "Manage Projects",
    "Permissions": [
      "Add",
      "Update",
      "Delete",
      "View"
    ]
  }
] */

/**
 * role right module function
 * @param {*} permissionFor
 * @param {*} moduleName
 * @returns
 */
export const RoleRightsForModule = (permissionFor, moduleName) => {
  const { loginUserData } = useContext(RoleContext);
  let isRetrun =
    loginUserData?.some(
      (data) =>
        data.Permissions.includes(permissionFor) && data.name === moduleName
    ) && true;
  return isRetrun;
};

/**
 * if any module have no right then this function will work
 * @param {*} moduleName
 * @returns
 */
export const NoModuleRights = (moduleName) => {
  const { loginUserData } = useContext(RoleContext);
  let isRetrun =
    loginUserData?.some(
      (data) => data.name === moduleName && data.Permissions.length <= 0
    ) && true;
  return isRetrun;
};

export const isValidNumber = (value) => {
  let regex = /^[+-]?\d*(?:\d*)?$/;
  return regex.test(value);
};
export const roleConditionName = ["View"];

export const getTimeAgoString = (syncedAtTime) => {
  // Parse the given date string into a Date object
  const givenDate = new Date(syncedAtTime);

  // Get the current date and time
  const currentDate = new Date();

  // Calculate the time difference in milliseconds
  const timeDifferenceInMilliseconds = currentDate - givenDate;

  // Convert milliseconds to minutes
  const timeDifferenceInMinutes = timeDifferenceInMilliseconds / (1000 * 60);

  switch (true) {
    case timeDifferenceInMinutes < 1:
      return "Few seconds ago";
    case timeDifferenceInMinutes >= 1 && timeDifferenceInMinutes < 2:
      return "1 minute ago";
    case timeDifferenceInMinutes >= 2 && timeDifferenceInMinutes < 3:
      return "2 minutes ago";
    case timeDifferenceInMinutes >= 3 && timeDifferenceInMinutes < 60:
      return "Few minutes ago";
    case timeDifferenceInMinutes >= 60 && timeDifferenceInMinutes < 120:
      return "1 hour ago";
    case timeDifferenceInMinutes >= 120 && timeDifferenceInMinutes < 180:
      return "2 hours ago";
    case timeDifferenceInMinutes >= 180 && timeDifferenceInMinutes < 1440:
      return "Few hours ago";
    case timeDifferenceInMinutes >= 1440 && timeDifferenceInMinutes < 2880:
      return "1 day ago";
    case timeDifferenceInMinutes >= 2880 && timeDifferenceInMinutes < 4320:
      return "Few days ago";
    case timeDifferenceInMinutes >= 4320 && timeDifferenceInMinutes < 86400:
      return "Few months ago";
    case timeDifferenceInMinutes >= 172800 && timeDifferenceInMinutes < 525600:
      return "1 year ago";
    case timeDifferenceInMinutes >= 525600:
      return "Few years ago";
    default:
      return "Long time ago";
  }
};

/**
 * Count number of words in a string
 * 
 * @param string
 * @return number
 */
export const wordCount = string => {
  return string ? string.split(" ").length : 0;
} 

export const getImageUrl = filename => {
  return process.env.REACT_APP_API_BASEURL + filename;
}

export const debounce = (callback, delay = 500) => {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => callback.apply(this, args), delay);
  };
}

export const extractAllLabels = labels =>  {
  const labelList = [];
  for (const label of labels) {
    labelList.push(label);
    if (label?.SubLabel?.length > 0) {
      labelList.push(...extractAllLabels(label.SubLabel));
    }
  }
  return labelList;
}
